import disableScroll from 'disable-scroll'
import { useEffect } from 'react'

import { A, Div, Img, Text } from 'components'
import { useSelector } from 'store'
import { selectPublicListing } from 'store/public-listing'
import { selectUserProfile } from 'store/users'
import { COLOR } from 'styles/constants'

import { Overlay } from './styled'

export const BlockOverlay: React.FC = () => {
  const { _id: userId } = useSelector(selectUserProfile)
  const { landlord_id: landlordId } = useSelector(selectPublicListing)
  const isListingOwner = landlordId === userId
  useEffect(() => {
    disableScroll.on()
    document.body.classList.add('no-scroll')
    return () => {
      disableScroll.off()
      document.body.classList.remove('no-scroll')
    }
  }, [])

  return (
    <Overlay>
      <Div $display="flex" $justifyContent="center" $alignItems="center">
        <Img src="/listing/listing-block.svg" alt="block-svg" />
      </Div>
      <Div
        $display="flex"
        $flexDirection="column"
        $justifyContent="center"
        $alignItems="center"
        $mt="55"
      >
        <Text $color={COLOR.BLACK} $bold $mb="10" $size="22px" $lineHeight="32px">
          {isListingOwner ? 'Listing Paused' : 'Listing Removed'}
        </Text>
        <Div $maxWidth="550px" $textAlign="center">
          {isListingOwner ? (
            <>
              <Text $color={COLOR.BLACK} $lineHeight="28px" $mSize="14px">
                To reactivate your listing, please contact the Support Team at
              </Text>
              <br />
              <Text $color={COLOR.BLACK} $lineHeight="28px" $mSize="14px">
                <A $decoration="none" href="tel:+3235157757">
                  {' '}
                  (323) 515-7757
                </A>{' '}
                or{' '}
                <A $decoration="none" href="mailto: support@rentspree.com">
                  support@rentspree.com
                </A>
                .
              </Text>
            </>
          ) : (
            <>
              <Text $color={COLOR.BLACK} $lineHeight="28px" $mSize="14px">
                Keep searching for your dream home.
              </Text>
            </>
          )}
        </Div>
      </Div>
    </Overlay>
  )
}
